<template>
  <v-autocomplete
    v-model="selected"
    :items="selectorOptions"
    :loading="loading"
    :label="labelForSelector"
    item-value="id"
    item-text="title"
    :search-input.sync="search"
    no-data-text="Ничего не найдено"
    prepend-inner-icon="mdi mdi-reload mdi-18px"
    no-filter
    multiple
    :rules="rule"
    @click:prepend-inner="refresh"
  >
    <!-- Чипсы в инпуте -->
    <template #selection></template>
    <template #append>
      <span v-if="selected.length <= 1" class="mr-2 mt-n1" style="max-width: 130px;">
        <v-chip small v-for="userId in selected" :key="`user_selector${userId}`">
          <span class="sliced-name">{{ getUserName(userId) }}</span>
        </v-chip>
      </span>

      <span v-else class="mt-n1">
        <v-chip small style="max-width: 130px;">
          <span class="sliced-name">{{ getUserName(selected[0]) }}</span>
        </v-chip>
        <span class="grey--text caption">(+{{ selected.length - 1 }})</span>
      </span>
    </template>

    <!-- Убираем чекбоксы в меню -->
    <template #item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.title"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>

    <!-- Строка "Выбрать всё" -->
    <template #prepend-item>
      <v-list-item v-if="!single" ripple @click="toggleAll">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ toggleAllText }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'UserSelector',
  props: {
    value: {
      required: true,
    },
    single: {
      type: Boolean,
      default: false,
    },
    noRules: {
      type: Boolean,
      default: false,
    },
    withSip: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      allSelectorOptions: [],
      selectorOptions: [],
      loading: false,
      search: null,
      labelForSelector: '',

      rule: [
        v => {
          if (this.noRules) return true
          else
            return !!v.length || 'Данное поле обязательно'
        }
      ],

      debounceRequest: null,
    }
  },

  computed: {
    ...mapGetters({}),

    selected: {
      get() {
        return this.value
      },
      set(selected) {
        this.$emit('input', selected)
      },
    },

    allItems() {
      return this.selected.length === this.selectorOptions.length
    },

    moreItems() {
      return this.selected.length > 0 && !this.allItems
    },

    icon() {
      if (this.allItems) return 'mdi-close-box'
      if (this.moreItems) return 'mdi-plus-box'
      return 'mdi-checkbox-blank-outline'
    },

    toggleAllText() {
      if (this.allItems) return 'Отменить все'
      if (this.moreItems) return 'Выбрать все'
      return 'Выбрать все'
    },

    filters() {
      let filters = `with_sip: ${this.withSip}`
      if (this.search && this.search !== '') {
        filters = `${filters}, search: "${this.search}"`
      }

      return `(${filters})`
    },
  },

  watch: {
    search(val, oldVal) {
      if (val === oldVal) return
      if (this.debounceRequest == null) return
      this.debounceRequest()
    },

    selected(val) {
      if (this.single) {
        if (val.length > 1) this.value.shift()
      }

      if (this.withSip) {
        let res = []

        val.map(item => {
          let payload = {}
          let user = this.selectorOptions.find(user => user.id === item)
          payload.sip = user.title.match(/\[(\d{4})\]/)[1]
          payload.name = user.title
          res.push(payload)
        })

        this.$emit('change:user', res)
      }
    },
  },

  methods: {
    ...mapActions({
      loadUsers: 'graphql/loadUsers',
    }),

    toggleAll() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.selected = []
        } else {
          this.selected = this.selectorOptions.map((p) => p.id)
        }
      })
    },

    async refresh() {
      this.selected = []
      this.search = ''
      await this.sendRequest()
    },

    async sendRequest() {
      this.loading = true

      let graphQuery = {
        query: `{
          users ${this.filters} {
            data {
              id
              title
            }
          }
        }`
      }

      await this.loadUsers(graphQuery).then(resp => {
        this.selectorOptions = resp.data

        if (!this.search) {
          this.allSelectorOptions = resp.data
        }
      })
      this.loading = false
    },

    getUserName(id) {
      const user = this.allSelectorOptions.find(p => p.id === id)

      if (user) return user.title
      else return ''
    },
  },

  async mounted() {
    if (this.label === '') {
      if (this.single) this.labelForSelector = 'Оператор'
      else this.labelForSelector = 'Операторы'
    } else this.labelForSelector = this.label

    await this.sendRequest()

    this.debounceRequest = this.utils.debounce(this.sendRequest, 700)
    this.$emit('loaded')
  },
}
</script>

<style scoped lang="scss">
.sliced-name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>